import { Form } from '@/components/Form';

const form = Form<SubscribeDto>();

export default form;

export type SubscribeDto = {
    firstName?: string;
    lastName?: string;
    email: string;
};
